<template>

    <div class="menu-footermusicbuiz-container">
        <ul id="menu-footermusicbuiz" class="menu">
            <li  v-for="route in myRoutes" 
                :key="route.ID" :class="route.classes" >
                <a :href="route.url"></a>
          </li>
        </ul>
    </div>
    
</template>
<script>

  export default {
    name: 'FooterMusicBuiz',
    data: () => {
      return {
        myRoutes: {},
      }
    },
    mounted () {
      this.getMenu();
    },
    computed: {
    },
    methods: {
      getMenu (){
        this.$http.get(
          '/menus/v1/menus/footerMusicBuiz')
        .then( (response) => {
          //console.log(response);
          this.myRoutes = response.data.items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

  };

</script>
